module.exports = __webpack_public_path__ + "static/media/romantic-vacation-mob.979b7904.jpg";